// extracted by mini-css-extract-plugin
export var backdropBlur = "_63-0";
export var body = "_63-5";
export var bodyScroll = "_63-6";
export var columnFooter = "_63-7";
export var columnFooterFlush = "_63-8";
export var contentColumn = "_63-4";
export var frame = "_63-3";
export var heroContent = "_63-c";
export var heroOverlay = "_63-b";
export var image = "_63-a";
export var imageWrapper = "_63-9";
export var modal = "_63-1";
export var modalMain = "_63-2";
export var productHeader = "_63-d";
export var productHeaderIcon = "_63-e";
export var productHeaderName = "_63-f";
export var progressIndicator = "_63-g";